var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"loading-container"},[_c('section',{staticClass:"loading-container__info"},[_c('div',{staticClass:"loading-container__info__circle"},[_c('FileTextSvg')],1),_c('div',{staticClass:"circle-wrap"}),_c('p',{staticClass:"loading-container__info__message"},[_vm._v(" "+_vm._s(_vm.currentMessage)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }